var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilyAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4.6,
    r: 3,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 8.7998C9.2713 8.79982 10.5017 9.17208 11.5361 9.85059C11.2084 10.1257 11 10.5385 11 11C10.1716 11 9.50001 11.6716 9.50001 12.5C9.50001 13.3284 10.1716 14 11 14C11 14.2943 11.086 14.5682 11.2324 14.7998H3.8252C2.67254 14.7997 1.70583 13.8806 2.08301 12.8369C2.39021 11.9869 2.89585 11.2058 3.57227 10.5576C4.74658 9.4324 6.33928 8.7998 8.00001 8.7998Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5H14M12.5 11V14",
    stroke: "currentColor",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyAdd);
export default __webpack_public_path__ + "static/media/family-add.569d98f7aee72e0f207be1df2d598de6.svg";
export { ForwardRef as ReactComponent };